module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-pagination-nav', {
    attrs: {
      "use-router": "",
      "link-gen": _vm.linkGen,
      "value": _vm.page,
      "number-of-pages": _vm.meta.totalPage
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d3d829a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/catalog/Pagination.vue
// module id = 3011
// module chunks = 0